import React from 'react';
import { Booking } from '../../types';
import { formatDate, formatTime, EVENT_DATES } from '../../utils/dateUtils';
import { Trash2, User, Building, Mail, Phone, Calendar } from 'lucide-react';
import { Button } from '../ui/Button';
interface BookingsListProps {
  bookings: Booking[];
  onDelete: (id: string) => void;
}
export function BookingsList({
  bookings,
  onDelete
}: BookingsListProps) {
  // Group bookings by date
  const bookingsByDate = EVENT_DATES.map(date => ({
    date,
    items: bookings.filter(b => b.date === date).sort((a, b) => a.time.localeCompare(b.time))
  }));
  return <div className="space-y-8" data-id="element-19">
      {bookingsByDate.map(({
      date,
      items
    }) => <div key={date} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-20">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-21">
            <h3 className="font-semibold text-gray-900 flex items-center gap-2" data-id="element-22">
              <Calendar className="w-4 h-4 text-gray-500" data-id="element-23" />
              {formatDate(date)}
            </h3>
            <span className="text-sm text-gray-500 bg-white px-2 py-1 rounded border border-gray-200" data-id="element-24">
              {items.length} bookings
            </span>
          </div>

          {items.length === 0 ? <div className="p-8 text-center text-gray-500" data-id="element-25">
              No bookings for this date
            </div> : <div className="divide-y divide-gray-100" data-id="element-26">
              {items.map(booking => <div key={booking.id} className="p-6 hover:bg-gray-50 transition-colors" data-id="element-27">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-28">
                    <div className="flex-1 space-y-2" data-id="element-29">
                      <div className="flex items-center gap-3" data-id="element-30">
                        <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-bold" data-id="element-31">
                          {formatTime(booking.time)}
                        </span>
                        <h4 className="font-bold text-gray-900 text-lg" data-id="element-32">
                          {booking.name}
                        </h4>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-sm text-gray-600 mt-2" data-id="element-33">
                        <div className="flex items-center gap-2" data-id="element-34">
                          <Building className="w-4 h-4 text-gray-400" data-id="element-35" />
                          {booking.company}
                        </div>
                        <div className="flex items-center gap-2" data-id="element-36">
                          <Mail className="w-4 h-4 text-gray-400" data-id="element-37" />
                          <a href={`mailto:${booking.email}`} className="hover:text-blue-600" data-id="element-38">
                            {booking.email}
                          </a>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-39">
                          <Phone className="w-4 h-4 text-gray-400" data-id="element-40" />
                          {booking.phone}
                        </div>
                      </div>
                    </div>

                    <Button variant="outline" size="sm" onClick={() => {
              if (confirm('Are you sure you want to delete this booking?')) {
                onDelete(booking.id);
              }
            }} className="text-red-600 hover:bg-red-50 hover:text-red-700 border-red-200 hover:border-red-300 shrink-0" data-id="element-41">
                      <Trash2 className="w-4 h-4 mr-2" data-id="element-42" />
                      Delete
                    </Button>
                  </div>
                </div>)}
            </div>}
        </div>)}
    </div>;
}